import { TextArea, TextAreaProps } from "semantic-ui-react";

type BPTextAreaProps = TextAreaProps & {};

export function BPTextArea(props: BPTextAreaProps) {
    return <TextArea {...props}>{props.children}</TextArea>;
}